export var getFooterNavLinks = function getFooterNavLinks(text) {
  return {
    primaryNav: [{
      parent: {
        navUrl: 'about/academic-integrity',
        navText: text[0],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'contactus/feedback',
        navText: text[1],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'contactus',
        navText: text[2],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'my/orders',
        navText: text[3],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }],
    legalNav: [{
      parent: {
        navUrl: 'cookienotice',
        navText: text[4],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'https://privacyportal.onetrust.com/webform/a21a74f4-2f93-44a2-a887-302a9213c997/06b040b7-49eb-464a-b19a-ea35c85c79fc',
        navText: text[5],
        useAbsolute: true,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: '#',
        navText: text[6],
        useAbsolute: true,
        configuration: {
          externalApi: null,
          navIconUrl: null,
          elementClassName: 'ot-sdk-show-settings',
          elementId: 'ot-sdk-btn',
          iconPosition: null,
          navType: null,
          __typename: 'NavConfiguration'
        },
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'generalpolicies',
        navText: text[7],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'privacypolicy',
        navText: text[8],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'honorcode',
        navText: text[9],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }, {
      parent: {
        navUrl: 'copyright',
        navText: text[10],
        useAbsolute: null,
        configuration: null,
        __typename: 'NavLinkItem'
      },
      children: null,
      __typename: 'NavElement'
    }],
    footerLegalNote: {
      navUrl: null,
      navText: text[11],
      useAbsolute: null,
      configuration: null,
      __typename: 'NavLinkItem'
    }
  };
};